<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <c-panel-container>
          <c-panel :img="itemObj.orderIcon" :title="itemObj.orderTitle"
                   :desc="`x ${itemObj.orderQuantity}`">
            <div class="price">{{ itemObj.totalPrice | currency0 }}</div>
          </c-panel>
        </c-panel-container>
        <c-cell-container>
          <c-cell class="cell-item" title="订单状态" :desc="itemObj.orderStatus"
                  :class="itemObj.orderStatusType" :point="false"></c-cell>
          <c-cell class="cell-item" title="购买时间" :desc="itemObj.shoppingDate"
                  :point="false"></c-cell>
          <c-cell class="cell-item" title="支付方式" :desc="itemObj.orderPayTypeDesc"
                  :point="false"></c-cell>
          <c-cell class="cell-item" title="订单号" :desc="itemObj.orderNum"
                  :point="false"></c-cell>
          <template v-if="itemObj.isRepay">
            <c-button @click.native="repay">重新支付</c-button>
          </template>
        </c-cell-container>
      </c-content>
    </c-page>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>

<script>
  import Pay from '../../../../model/pay/index'
//  import device from '../../../../tools/device'
  export default{
    data () {
      return {
        agent: false // device.android
      }
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {
      repay: function () {
        let pay = new Pay()
        pay.rePay(this.itemObj.orderId)
      }
    },
    computed: {
      itemObj () {
        return this.$store.getters.getOrderListItemDetail
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?33acd8f1